'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ = require('.');

var _Text = require('../Text');

var _Avatar = require('../Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _jssThemeReactor = require('jss-theme-reactor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('CollapsedListItem', function (theme) {
  var mixins = theme.mixins,
      palette = theme.palette,
      spacing = theme.spacing,
      typography = theme.typography,
      variables = theme.variables,
      zIndex = theme.zIndex;

  var height = spacing.unit / 2;

  return {
    root: {
      padding: 0,
      marginTop: typography.rhythmByUnit(-1),
      marginBottom: typography.rhythmByUnit(-1),
      height: typography.rhythmByUnit(7),
      backgroundColor: palette.background.paper,
      zIndex: zIndex.baseIndex,
      position: 'relative',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      }
    },
    avatar: {
      backgroundColor: palette.background.paper,
      color: palette.text.divider,
      borderWidth: variables.borderWidth,
      borderStyle: 'solid',
      borderColor: palette.text.divider,
      borderRadius: '50%',
      top: parseInt(typography.rhythmByUnit(2)) - variables.borderWidth - height,
      left: typography.rhythmByUnit(2),
      position: 'absolute'
    },
    box: {
      borderTop: '1px solid ' + palette.text.divider,
      borderBottom: '1px solid ' + palette.text.divider,
      width: '100%',
      height: height
    },
    label: mixins.truncate({
      display: 'inline-block',
      position: 'relative',
      top: '-1em',
      marginLeft: '5em',
      padding: '0.4em',
      backgroundColor: palette.background.paper
    })
  };
});

var CollapsedListItem = (_temp = _class = function (_PureComponent) {
  _inherits(CollapsedListItem, _PureComponent);

  function CollapsedListItem() {
    _classCallCheck(this, CollapsedListItem);

    return _possibleConstructorReturn(this, (CollapsedListItem.__proto__ || Object.getPrototypeOf(CollapsedListItem)).apply(this, arguments));
  }

  _createClass(CollapsedListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            count = _props.count,
            label = _props.label,
            _onClick = _props.onClick;

        var classes = this.context.styleManager.render(styleSheet);
        return _react2['default'].createElement(
          _.ListItem,
          {
            className: classes.root,
            onClick: function () {
              function onClick(e) {
                return _onClick(e, _this2.props);
              }

              return onClick;
            }(),
            dense: true
          },
          _react2['default'].createElement(
            _.ListItemIcon,
            null,
            _react2['default'].createElement(
              _Avatar2['default'],
              { className: classes.avatar },
              _react2['default'].createElement(
                _Text.Body1,
                null,
                count
              )
            )
          ),
          _react2['default'].createElement(
            'div',
            { resource: 'expand', className: classes.box },
            label && _react2['default'].createElement(
              _Text.Body1,
              { className: classes.label },
              label
            )
          )
        );
      }

      return render;
    }()
  }]);

  return CollapsedListItem;
}(_react.PureComponent), _class.propTypes = {
  /**
   * Number of collapsed list items represented by CollapsedListItem.
   */
  count: _PropTypes2['default'].number,
  /**
   * Function called when CollapsedListItem is clicked;
   * should be wired in List to display hidden list items.
   */
  onClick: _PropTypes2['default'].func,
  /**
   * Beginning index of parent List's children represented by CollapsedListItem.
   */
  startIdx: _PropTypes2['default'].number,
  /**
   * Label to show in the collapsed section beside number
   */
  label: _PropTypes2['default'].string
}, _class.defaultProps = {
  count: 0
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = CollapsedListItem;


CollapsedListItem.displayName = 'CollapsedListItem';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/CollapsedListItem.js
// module id = 641
// module chunks = 32